import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import { validationByJoi } from '../utilities/commonValidation';

import { CranePrintSentencesService } from '../services/CranePrintSentences';
import {
  CranePrintSentenceContents,
  craneAndMachineryCodeList,
  typeList,
} from '../components/tables/CranePrintSentence';
import { Edited } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { Information } from '../components/modals/common';
import { messageUtility } from '../utilities/messageUtility';

export class CranePrintSentences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      crane_print_sentences: [],
      errors: [],
      visibleErrorDialog: false,
    };
    this.formKeys = ['id', 'sentence', 'type', 'code'];
    this.events = {
      table: {
        onChangeSentence: this.onChangeSentence,
      },
    };
    this.schema = Joi.object().keys({
      id: Joi.allow(),
      sentence: Joi.string()
        .max(512)
        .allow('')
        .optional(),
      type: Joi.number().required(),
      code: Joi.number().required(),
    });
  }

  componentDidMount() {
    this.getCranePrintSentences();
  }

  getCranePrintSentences() {
    const fieldId = this.state.fieldId;
    CranePrintSentencesService.list(fieldId).then(resp => {
      if (resp.result) {
        let crane_print_sentences = this.cleanCranePrintSentences(
          resp.data.entities.crane_print_sentences
        );
        const craneAndMachineryCodes = _.map(craneAndMachineryCodeList, 'code');
        const fixedTypes = _.map(_.filter(typeList, 'isDefault'), 'type');
        const fixedSentences = _.flatMap(fixedTypes, type =>
          _.map(craneAndMachineryCodes, code => ({
            id: 0,
            type,
            code,
            sentence: '',
          }))
        );
        const additionalSentences = _.filter(
          fixedSentences,
          ({ type, code }) => {
            return !_.some(crane_print_sentences, { type, code });
          }
        );
        crane_print_sentences = _.concat(
          crane_print_sentences,
          additionalSentences
        );
        this.setState({ crane_print_sentences });
      }
    });
  }

  onChangeSentence = (e, index) => {
    const crane_print_sentences = this.state.crane_print_sentences;
    crane_print_sentences[index][e.target.name] = e.target.value;
    this.setState({
      crane_print_sentences,
    });
  };

  cleanCranePrintSentences = cranePrintSentences =>
    _.map(cranePrintSentences, cranePrintSentence =>
      _.pick(cranePrintSentence, this.formKeys)
    );

  editSentences = () => {
    const fieldId = this.state.fieldId;
    const crane_print_sentences = this.state.crane_print_sentences;
    const errors = [];
    // eslint-disable-next-line no-unused-vars
    _.each(crane_print_sentences, (crane_print_sentence, index) => {
      const result = validationByJoi(this.schema, crane_print_sentences);
      const errors = {};
      if (!result.status) {
        _.each(result.messages, (message, name) => {
          errors[name] = message;
        });
      }
    });
    if (errors.length === 0) {
      const params = {
        crane_print_sentences: this.state.crane_print_sentences,
      };
      CranePrintSentencesService.create(fieldId, params).then(resp => {
        if (!resp.result) {
          return this.setState({
            visibleErrorDialog: true,
          });
        }
        this.setState({
          crane_print_sentences: this.cleanCranePrintSentences(
            resp.data.entities.crane_print_sentences
          ),
        });
        this.updateDialog();
      });
    } else {
      this.setState({
        errors,
      });
    }
  };

  updateDialog() {
    dialogLoader.show(Edited);
  }

  render() {
    return (
      <div className='setting-main__body'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - 「揚重機・機材」帳票 文言設定
          </title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          <div className='setting-header__item'>
            <button className='btn--effective' onClick={this.editSentences}>
              更新
            </button>
          </div>
        </div>
        <CranePrintSentenceContents
          callbacks={this.events}
          cranePrintSentences={this.state.crane_print_sentences}
          errors={this.state.errors}
        />
        <Information
          visible={this.state.visibleErrorDialog}
          title={messageUtility.getMessage('E-001-402')}
          message={messageUtility.getMessage('E-000-055')}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
          onClose={() => this.setState({ visibleErrorDialog: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CranePrintSentences.jsx